// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"52":"b78242af","413":"af6d45f6","882":"58e03e73"}[chunkId] + ".chunk.js";
};